<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            :title='wos.title'
            :titleIcon='wos.icon'
            :titleIconColor='wos.iconColor'
            showArchived
            :showArchivedStatus='showArchived'
            @toggleShowArchived='showArchived = !showArchived'
            showHelp
            helpText='Estimate Work Orders that may be connected to this Project will NOT appear here.<br><br>Use the Project Estimates tab to select the Estimate, and a link to the Work Order generated from that Estimate (if there is one) will be available in the basics box.'
          >
            <template v-slot:appendToolbarButtons>
              <wc-toolbar-search v-model='search'></wc-toolbar-search>
              <v-menu offset-y left>
                <template v-slot:activator='{ on: menu }'>
                  <v-tooltip top :open-delay='500' :disabled='!project.archived && !project.on_hold'>
                    <template v-slot:activator='{ on: tooltip }'>
                      <div v-on='{...tooltip}' class='d-inline-block mr-n2'>
                        <v-btn icon small v-on='{...menu}' :disabled='project.archived || project.on_hold'>
                          <v-icon color='grey lighten-1'>mdi-plus</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <span class='caption'>You cannot create work orders if a project is on hold or archived</span>
                  </v-tooltip>
                </template>
                <v-list dense>
                  <v-subheader>NEW WORK ORDER TYPE</v-subheader>
                  <v-divider></v-divider>
                  <v-list-item v-for='w in filteredWoTypes' :key='w.id' @click='openAdd(w)'>
                    <v-list-item-icon class='ml-0 mr-2'>
                       <v-badge inline :color='w.color'></v-badge>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class='subtitle-2'>{{ w.name }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <v-data-table
              :items='filteredProjectWOs'
              dense
              :search='search'
              :headers='formattedHeader'
              :items-per-page='-1'
              hide-default-footer
              @click:row='openWO'
            >
              <template v-slot:item.wo_type='{ item }'>
                {{ getWOType(item).name }}
              </template>
              <template v-slot:item.status='{ item }'>
                <wo-status small :wo='item'></wo-status>
                <!-- <wo-timeline small right :timeline='item.timeline'></wo-timeline> -->
              </template>
              <template v-slot:item.date_scheduled='{ item }'>
                {{ item.date_scheduled | shortDate }}
              </template>
              <template v-slot:item.date_completed='{ item }'>
                {{ item.date_completed | shortDate }}
              </template>
              <template v-slot:item.problem_description='{ item }'>
                <div class='text-truncate' style="max-width: 400px;">{{ stripHtml(item.problem_description) }}</div>
              </template>

            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>

    <wc-dialog
      :showDialog='showAddDialog'
      title='New Work Order'
      :icon='wos.icon'
      :iconColor='wos.iconColor'
      @cancel='showAddDialog = false'
      @save='createWO'
    >
      <v-textarea
        outlined
        label='Problem description'
        v-model='newWO.problem_description'
      ></v-textarea>
    </wc-dialog>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import wosAPI from '@/modules/wos/api'
import WOStatus from '@/modules/wos/components/WOStatus'
// import WOTimeline from '@/modules/wos/components/WOTimeline'
import _ from 'lodash'

export default {
  name: 'project-wos',
  props: {
    project: {
      required: true
    }
  },
  data: () => ({
    isLoading: true,
    showAddDialog: false,
    showArchived: false,
    projectWOs: [],
    newWO: {
      project: null,
      created_by: null,
      problem_description: '',
      wo_type: ""
    },
    search: '',
    headers: [
      { text: 'Number', value: 'number', width: '200' },
      { text: 'Type', value: 'wo_type' },
      { text: 'Problem Description', value: 'problem_description' },
      { text: 'Status', value: 'status', align: 'center' },
      { text: 'Scheduled', value: 'date_scheduled', align: 'end' },
      { text: 'Completed', value: 'date_completed', align: 'end' }
    ]
  }),
  computed: {
    formattedHeader () {
      let newHeader = this.headers
      for (let h in newHeader) {
        newHeader[h].class = 'overline'
      }
      return newHeader
    },
    ...mapState({
      wos: state => state.icons.modules.workorders,
      woTypes: state => state.misc.woTypes
    }),
    filteredWoTypes () {
      let tmp = this.woTypes.filter( w => w.division === this.project.division )
      tmp = tmp.filter(w => w.archived == false)
      // have to filter out estimate wotype as these should likely only be created from an estimate page.
      return tmp.filter( w => w.category !== "ES" )
    },
    filteredProjectWOs () {
      if (this.showArchived) {
        return this.projectWOs
      }
      return this.projectWOs.filter( w => !w.archived )
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.projectWOs = await wosAPI.getProjectWOs(this.project.id)
      this.isLoading = false
    },
    openWO (wo) {
      this.$router.push({ name: 'WOOverview', params: { id: wo.id } })
    },
    openAdd (woType) {
      this.newWO.project = this.project.id
      this.newWO.created_by = this.$store.state.auth.profile.id
      this.newWO.problem_description = ''
      this.newWO.wo_type = woType.id
      this.showAddDialog = true
    },
    async createWO () {
      let tmp = await wosAPI.createWO(this.newWO)
      this.showAddDialog = false
      this.openWO(tmp)
    },
    getWOType (item) {
      return _.find(this.woTypes, function(w) { return w.id === item.wo_type })
    },
    stripHtml(html) {
      // Create a new div element
      let temporalDivEl = document.createElement("div");
      // Set HTML content using provider
      temporalDivEl.innerHTML = html;
      // Get the text property of the element (browser support)
      return temporalDivEl.textContent || temporalDivEl.innerText || "";
    }
  },
  components: {
    'wo-status': WOStatus,
    // 'wo-timeline': WOTimeline
  }
}
</script>
